import { ProjectSubType, PublicationStatus } from '@prisma/client';
import { ImpactType } from '../impact';
import { isLocalReforestationProjectSubType } from '../tree-projects';

export const MANUALLY_INVOICEABLE_TREE_PROJECT_IDS = new Set([
  8953, 11275, 11351, 11353, 11355, 11257, 11167, 5290, 11256,
]);

export type ProjectForManualInvoicing = {
  id: number;
  impactType: `${ImpactType}`;
  projectSubType?: ProjectSubType | null;
  status: PublicationStatus;
};

export const isProjectValidForManualInvoicing = ({
  didOriginateFromProjectMix = false,
  project,
}: {
  didOriginateFromProjectMix?: boolean;
  project: ProjectForManualInvoicing;
}): boolean => {
  if (project.status !== PublicationStatus.LIVE) return false;

  if (project.impactType === 'TREES') {
    if (isLocalReforestationProjectSubType(project.projectSubType)) return true;
    if (MANUALLY_INVOICEABLE_TREE_PROJECT_IDS.has(project.id)) return true;
    if (!didOriginateFromProjectMix) return false;
  }

  return true;
};
